export default "<div class=\"extra-div\"></div>\r\n<app-services [servicesName]=\"servicesName\"></app-services>\r\n<app-cta></app-cta>\r\n"